module.exports = __webpack_public_path__ + "static/media/finger_hang_update.c9da1756.svg";